import SingleBedroom from '@spa/shared/svg/single-bedroom';
import SharedBedroom from '@spa/shared/svg/shared-bedroom';
import Studio from '@spa/shared/svg/studio';
import Apartment from '@spa/shared/svg/apartment';
import SingleBed from '@spa/shared/svg/single-bed';
import DoubleBed from '@spa/shared/svg/double-bed';
import OutdoorArea from '@spa/shared/svg/outdoor-area';
import Balcony from '@spa/shared/svg/balcony';
import Window from '@spa/shared/svg/window';

export const OFFER_UNIT_TYPE = {
  bedroom: {
    Component: SingleBedroom,
    translation: 'unit_type.bedroom.label',
    translation_plural: 'unit_type.bedrooms.label',
    description: 'unit_type.bedroom.description',
    offerType: 'bedroom'
  },
  'single-bed': {
    Component: SharedBedroom,
    translation: 'unit_type.shared_bedroom.label',
    translation_plural: 'unit_type.shared_bedrooms.label',
    description: 'unit_type.shared_bedroom.description',
    offerType: 'shared-bedroom'
  },
  'double-bed': {
    Component: SharedBedroom,
    translation: 'unit_type.shared_bedroom.label',
    translation_plural: 'unit_type.shared_bedrooms.label',
    description: 'unit_type.shared_bedroom.description',
    offerType: 'shared-bedroom'
  },
  apartment: {
    Component: Apartment,
    translation: 'unit_type.apartment.label',
    translation_plural: 'unit_type.apartments.label',
    description: 'unit_type.apartment.description',
    offerType: 'apartment'
  },
  studio: {
    Component: Studio,
    translation: 'unit_type.studio.label',
    translation_plural: 'unit_type.studios.label',
    description: 'unit_type.studio.description',
    offerType: 'studio'
  }
};

export const UNIT_TYPE = {
  bed: {
    Component: SingleBed,
    translation: 'Bed',
    exists: true
  },
  'single-bed': {
    Component: SingleBed,
    translation: 'Single bed',
    exists: true
  },
  'double-bed': {
    Component: DoubleBed,
    translation: 'Double bed',
    exists: true
  }
};

export const OUTSIDE_CONNECTION = {
  'outside-area': {
    Component: OutdoorArea,
    translation: 'Outdoor area'
  },
  balcony: {
    Component: Balcony,
    translation: 'Balcony'
  },
  window: {
    Component: Window,
    translation: 'Window'
  }
};
